import styled from 'styled-components';
import {Space} from 'antd';

const StyledTransactionDetails = styled(Space)`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > .ant-space-item {
    width: 100%;
  }

  .ant-card-head {
    background-color: ${props => props.theme.colors.neutral_2};
  }

`;

export {
  StyledTransactionDetails
};
